import { NavigationTheme } from '@components/navigation/enum';
import { NavigationStyle } from '@components/navigation/model';

export const navigationStyle: { [key: string]: NavigationStyle } = {
  [NavigationTheme.WHITE]: {
    backgroundColor: 'TRANSPARENT',
    textColor: 'WHITE',
    menuBackgroundColor: 'BLUE',
    menuTextColor: 'WHITE',
    menuLinkOpacity: 0.5,
    socialNetworksStyle: 'TRANSPARENT_WHITE',
    cta: {
      size: 'NORMAL',
      theme: 'FULL_WHITE',
    },
    ctaSecondaryTheme: 'TRANSPARENT_WHITE',
  },
  [NavigationTheme.BLACK]: {
    backgroundColor: 'TRANSPARENT',
    textColor: 'BLACK',
    menuBackgroundColor: 'BLUE',
    menuTextColor: 'WHITE',
    menuLinkOpacity: 0.5,
    socialNetworksStyle: 'TRANSPARENT_WHITE',
    cta: {
      size: 'NORMAL',
      theme: 'BLUE',
    },
    ctaSecondaryTheme: 'TRANSPARENT_BLACK',
  },
  [NavigationTheme.OPAL_BLACK]: {
    backgroundColor: 'TRANSPARENT',
    textColor: 'BLACK',
    menuBackgroundColor: 'OPAL',
    menuTextColor: 'BLACK',
    menuLinkOpacity: 1,
    socialNetworksStyle: 'TRANSPARENT_BLACK',
    cta: {
      size: 'NORMAL',
      theme: 'TRANSPARENT_BLACK',
    },
    ctaSecondaryTheme: 'TRANSPARENT_BLACK',
  },
  [NavigationTheme.OPAL_WHITE]: {
    backgroundColor: 'TRANSPARENT',
    textColor: 'WHITE',
    menuBackgroundColor: 'OPAL',
    menuTextColor: 'BLACK',
    menuLinkOpacity: 1,
    socialNetworksStyle: 'TRANSPARENT_BLACK',
    cta: {
      size: 'NORMAL',
      theme: 'FULL_WHITE',
    },
    ctaSecondaryTheme: 'TRANSPARENT_WHITE',
  },
};
